module.exports = __webpack_public_path__ + "static/media/bar1.04e69434.svg";